import { memo } from "react";
import { Grid2 } from "@mui/material";
import ChatDetails from "@chat/components/chatlist/details/ChatDetails";
import { useChatSelectionSlice } from "@store/slices/chatSelection";
import { availableViewportHeight } from "@core/layout/AppLayout";
import { useViewSlice } from "@store/slices/view";
import { Query } from "@/app/graphql/codegen";
import { FETCH_CHATS } from "@chat/graphql/queries/fetchChats";
import { useQuery } from "@apollo/client";
import { ChatList } from "@chat/components/chatlist/list/ChatList";

/**
 * TODO Es wäre cool, wenn der zuletzt aktive Chat automatisch angewählt ist.
 * TODO Die Filterung/Sortierung der letzten Sitzung könnte aus dem localStorage erinnert werden
 */
const ChatListPage = memo(() => {
    const { data } = useQuery<Pick<Query, "chats">>(FETCH_CHATS);
    const chats = data?.chats ?? [];
    const hasChats = chats.length > 0;

    const { id } = useChatSelectionSlice();
    const { showExtendedView } = useViewSlice();

    // Calculate grid size based on screen size and chat existence
    const leftGridSize = hasChats ? { xs: 12, sm: id ? 6 : 12 } : { xs: 0 };
    const rightGridSize = hasChats ? { xs: 12, sm: id ? 6 : 12 } : { xs: 12 };

    return (
        <Grid2 container spacing={6} sx={{ border: `${showExtendedView ? 1 : 0}px solid blue` }} overflow={"hidden"} height={availableViewportHeight}>
            {/* Linke Seite mit Chatliste - nur anzeigen, wenn es Chats gibt */}
            {hasChats && (
                <Grid2
                    container
                    size={leftGridSize}
                    sx={{
                        border: `${showExtendedView ? 1 : 0}px solid green`,
                        "&::-webkit-scrollbar": { display: "none" },
                        scrollbarWidth: "none",
                    }}
                    overflow={"auto"}
                    height={availableViewportHeight}
                >
                    <ChatList />
                </Grid2>
            )}

            {/* Rechte Seite mit Chatdetails */}
            <Grid2
                size={rightGridSize}
                sx={{
                    border: `${showExtendedView ? 1 : 0}px solid red`,
                    "&::-webkit-scrollbar": { display: "none" },
                    scrollbarWidth: "none",
                }}
                overflow={"auto"}
                height={availableViewportHeight}
            >
                <ChatDetails />
            </Grid2>
        </Grid2>
    );
});

export default ChatListPage;
